import "../scss/style.scss";
import $ from "jquery";
import { TweenMax, Power2, TimelineLite } from "gsap";
import Sticky from "sticky-js";
// import picturefill from 'picturefill';
import scrollmonitor from "scrollmonitor";
// import ScrollToPlugin from "gsap/ScrollToPlugin";
import tocbot from "tocbot";
var imagesLoaded = require("imagesloaded");
import frontNavHover from "./frontNavHover";

/**
 * Since this script is included in the <head> we have to listen
 * for the DOMContentLoaded event.
 */
document.addEventListener("DOMContentLoaded", function (event) {
  document.createElement("picture");
  var $window = $(window);
  var sticky = new Sticky(".sticky");
  frontNavHover();

  // Show / hide google translate
  const showTranslateButton = document.getElementById("showTranslateButton");
  const translateContainer = document.getElementById("translateContainer");
  if (showTranslateButton && translateContainer) {
    showTranslateButton.addEventListener("click", function () {
      if (translateContainer.style.display === "none") {
        translateContainer.style.display = "block";
      } else {
        translateContainer.style.display = "none";
      }
    })
  }

  //Remove empty p tags from article
  $("p").each(function (index, item) {
    if ($.trim($(item).text()) === "") {
      $(item).remove();
    }
  });

  // You images done yet or what?
  $(".article__gallery")
    .find("img")
    .each(function () {
      var _this = $(this);
      imagesLoaded(_this, function () {
        TweenMax.to(_this, 0.3, {
          opacity: 1,
          delay: 0.2,
          ease: Power2.easeIn,
        });
        _this.addClass("loaded");
      });
    });

  // megamenu
  function megaMenu() {
    $(".nav__item-menu-toggle-button").click(function () {
      if ($("body").hasClass("masternav-open")) {
        $(".nav__item-menu-toggle-button").removeClass("is-open");
        $(".nav__item-menu-toggle-button").attr("aria-expanded", "false");
        $(".page-header__mega-menu").attr("aria-expanded", "false");
        $(".page-header .nav__item-menu-toggle-button").text("Meny");
        $("body, header#top").removeClass("masternav-open");
        TweenMax.to($("#masternav"), 0.15, { autoAlpha: 0 });
      } else {
        $(".nav__item-menu-toggle-button").addClass("is-open");
        $(".page-header__mega-menu").attr("aria-expanded", "true");
        $(".nav__item-menu-toggle-button").attr("aria-expanded", "true");
        $(".page-header .nav__item-menu-toggle-button").text("Lukk");
        $("body, header#top").addClass("masternav-open");
        TweenMax.to($("#masternav"), 0.15, { autoAlpha: 1 });
      }
    });
  }

  // equalize heights on elements
  function equalizeHeights(elem) {
    var maxHeight = 0;
    elem.each(function () {
      var h = $(this).height();
      if (h > maxHeight) {
        maxHeight = h;
      }
    });
    elem.height(maxHeight);
  }

  // check for different browser widths
  function resizeCheck() {
    var pageWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    var pageHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    //IE fix for mega menu background
    $(".mega-menu__background").width(pageWidth);

    //toc container
    if (pageWidth <= 1080) {
      $(".toc__mobile-container").prepend($(".toc"));
    } else {
      $(".sticky__item-last").prepend($(".toc"));
    }

    if (pageWidth <= 769) {
      $(".mega-menu__block-item, .grid-nav__item a").height("auto");
      $(".global-search__form-input").autofocus = true;
    } else {
      equalizeHeights($(".mega-menu__block-item"));
      equalizeHeights($(".grid-nav__item a"));
    }

    //fix frontpage article image height
    $(".front-featured__featuredArticleImage").each(function () {
      var img = $(this).find(".front-featured__image"),
        heading = $(this).find("h2");

      img.parent().mouseenter(function () {
        heading.addClass("hovered");
      });
      img.parent().mouseleave(function () {
        heading.removeClass("hovered");
      });
    });
  }

  // change height on article btns
  function changeBtnHeight() {
    $(".article__link").each(function () {
      var svg = $(this).find("svg");
      var span = $(this).find("span").height();
      svg.css("height", span + 22);
    });
  }

  //article alert box
  function changeArticleAlertHeight() {
    $(".article-alert").each(function () {
      var t = $(this);
      var thisHeight = $(this).height();
      $(this).css("margin-top", -thisHeight);
      $(this).one("click", "#alert-cross", function () {
        TweenLite.to(t, 0.6, { y: thisHeight, ease: Expo.easeOut });
      });
    });
  }

  //gallery
  function articleGallery() {
    var $galleryItem = $(".article__gallery-list__item"),
      $figure = $(".article__gallery-lightbox__figure"),
      $figureTitle = $(".article__gallery-lightbox__figure--title"),
      $figureImage = $(".article__gallery-lightbox__figure--image");

    // Handle item click
    $($galleryItem).on("click", function () {
      var full = $(this).attr("data-full");
      var fullAlt = $(this).attr("data-alt");
      $(".article__gallery-list__item--wrapper").removeClass("active");
      $(this).find("a").addClass("active");
      toggleLightbox(full, fullAlt);
    });

    // Toggle lightbox
    function toggleLightbox(full, fullAlt) {
      TweenMax.to($figure, 0.3, {
        opacity: 0,
        ease: Power2.easeOut,
        onComplete: showImage,
      });
      function showImage() {
        $figureImage
          .on("load error", function () {
            TweenMax.to($figure, 0.3, { opacity: 1, ease: Power2.easeIn });
            $figureTitle.text(fullAlt);
          })
          .attr("src", full)
          .attr("alt", fullAlt);
      }
    }
    $(".article__gallery-list__item--wrapper").on("click", function (e) {
      e.preventDefault();
    });
  }

  //toc list
  function stickyToc() {
    $(".article__blocks h2").each(function () {
      var thisText = $(this)
        .text()
        .toLowerCase()
        .replace(/ø|Ø/g, "o")
        .replace(/å|Å/g, "a")
        .replace(/[\. ,:-]+/g, "-")
        .replace(/\s/g, "");
      this.id = thisText;
    });

    const width = $(window).width();
    let offset;

    if (width < 1080) {
      offset = 130;
    } else {
      offset = 118;
    }

    if ($(".toc-wrapper").length) {
      tocbot.init({
        tocSelector: ".toc-wrapper",
        contentSelector: ".article__item-first",
        headingSelector: "h2",
        scrollSmoothDuration: 720,
        linkClass: "toc__link",
        listItemClass: "toc__list-item",
        activeLinkClass: "active",
        listClass: "toc__list",
        headingsOffset: offset,
        scrollSmoothOffset: -offset,
      });

      var tocMobileContainer = scrollMonitor.create(
        $(".toc__mobile-container")
      );
      tocMobileContainer.enterViewport(function () {
        $(".scroll-top").removeClass("visible");
      });
      tocMobileContainer.exitViewport(function () {
        $(".scroll-top").addClass("visible");
      });

      $(".scroll-top").click(function () {
        TweenLite.to(window, 0.8, {
          scrollTo: ".article-content",
          ease: Power2.easeOut,
        });
      });
    }
  }

  //make all article contacts the same height
  function personsHeight() {
    $(".persons__wrapper").each(function () {
      var maxheight = 0,
        person = $(this).find(".person");
      $(person).each(function () {
        maxheight = $(this).height() > maxheight ? $(this).height() : maxheight;
      });
      $(person).height(maxheight);
    });
  }

  //toggle contact persons
  $(".article__persons").each(function () {
    var bottom = $(this).find(".persons__outer");
    var bottomContent = $(this).find(".persons__outer .persons__wrapper");
    var heading = $(this).find(".persons__heading");

    function showPersons() {
      $(this).find("svg").addClass("clicked");
      $(bottomContent).fadeIn();
      TweenLite.set(bottom, { css: { height: "auto" } });
      TweenLite.from(bottom, 0.3, {
        css: { height: 0 },
        ease: Expo.easeInOut,
        y: 0,
      });
      TweenLite.to(bottom, 0.3, {
        css: { opacity: 1 },
        delay: 0.1,
        ease: Expo.easeInOut,
        y: 0,
      });
      $(this).one("click", hidePersons);
    }

    function hidePersons() {
      $(this).find("svg").removeClass("clicked");
      $(bottomContent).fadeOut();
      TweenLite.to(bottom, 0.3, {
        css: { height: 0 },
        opacity: 0,
        delay: 0.1,
        ease: Expo.easeInOut,
        y: 0,
      });
      $(this).one("click", showPersons);
    }

    heading.one("click", showPersons);
  });

  // change header when scrolling past image
  function headerChange() {
    var totScroll = 0;
    var header = $("header#top");
    var headerHeight = header.height();
    var scrollHeight = Math.ceil($(".top-image-header").height());

    if ($("body").hasClass("is-homepage")) {
      if (
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth <= 769
      ) {
        totScroll = scrollHeight - 100;
      } else {
        totScroll = scrollHeight - 144;
      }
    } else {
      totScroll = scrollHeight - headerHeight;
    }

    function changeHeaderColor() {
      var scroll = $(window).scrollTop();
      if (scroll >= totScroll) {
        header.removeClass("clear-header").addClass("white-header");
        $(".sticky").addClass("is-sticky");
      } else {
        header.removeClass("white-header").addClass("clear-header");
        $(".sticky").removeClass("is-sticky");
      }
    }
    changeHeaderColor();

    $(window).scroll(function () {
      changeHeaderColor();
    });
  }

  //search filter function
  function searchFilter() {
    var filterArray = [];
    var counts = {};

    if ($(".global-search").length) {
      $(".search-results__item").each(function () {
        var section = $(this).attr("data-section");
        if (section) {
          filterArray.push(section);
        }
      });

      filterArray.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      var links = Object.keys(counts).map(function (key) {
        return (
          '<button data-filter=".' +
          key.replace(/ /g, "-").replace(/,/g, "").toLowerCase() +
          '" class="filter__btn">' +
          key +
          " " +
          '<span class="filter__count">(' +
          counts[key] +
          ")</span></button>"
        );
      });

      $("#searchFilter").html(links);

      // init Isotope
      var iso = new Isotope(".search-results", {
        itemSelector: ".search-results__item",
        layoutMode: "fitRows",
      });

      var filtersElem = document.querySelector(".filters-button-group");
      filtersElem.addEventListener("click", function (event) {
        if (!matchesSelector(event.target, "button")) {
          return;
        }
        var filterValue = event.target.getAttribute("data-filter");
        iso.arrange({ filter: filterValue });
        hideFilter();
      });

      $(".filter__btn").on("click", function () {
        $(this).addClass("is-active").siblings().removeClass("is-active");
      });

      function showFilter() {
        $("#toggleFilter").addClass("clicked");
        TweenMax.to(".filter__group", 0.25, {
          opacity: 1,
          autoAlpha: 1,
          delay: 0.15,
          ease: Circ.easeOut,
        });
        TweenLite.set(".filter__outer", { css: { height: "auto" } });
        TweenLite.from(".filter__outer", 0.4, {
          css: { height: 0 },
          ease: Expo.easeOut,
          y: 0,
        });
      }

      function hideFilter() {
        $("#toggleFilter").removeClass("clicked");
        TweenMax.to(".filter__group", 0.25, {
          opacity: 0,
          autoAlpha: 0,
          ease: Circ.easeOut,
        });
        TweenLite.to(".filter__outer", 0.25, {
          css: { height: 0 },
          opacity: 0,
          delay: 0.15,
          ease: Expo.easeOut,
          y: 0,
        });
      }

      //mobile dropdown filter
      $("#toggleFilter").on("click", function () {
        if ($(this).hasClass("clicked")) {
          hideFilter();
        } else {
          showFilter();
        }
      });
    }
  }

  $(window).resize(function () {
    $(".persons__wrapper .person").css("height", "auto");
    personsHeight();
    headerChange();
  });

  stickyToc();
  headerChange();
  articleGallery();
  personsHeight();
  changeBtnHeight();
  megaMenu();
  resizeCheck();
  changeArticleAlertHeight();
  searchFilter();
  $window.resize(resizeCheck);
  $window.resize(changeBtnHeight);
  $window.resize(changeArticleAlertHeight);
});
